export default "__VITE_ASSET__5885fc04__"